import { useRecoilValue } from "recoil";
import upperDataStore from "../stores/upperData";

export const useTranslation = () => {
    const { translate } = useRecoilValue(upperDataStore);
    return translate;
};